const wrapper = "_araw13ct96t";
const heading = "_arah1seh9gu";
const solidBox = "_aras1l8obqk";
const solidTextBox = "_aras1gkz4x7";
const inputBox = "_araimaqozz";
const scrambledCardStyles = {
  wrapper,
  heading,
  solidTextBox,
  solidBox,
  inputBox
};

export { inputBox, scrambledCardStyles };
import "./scrambled.card.style.linaria.module.css";
//# sourceMappingURL=scrambled.card.style.js.map
